/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasLedgersLedgerIcrc1MetadataMintingAccount = {
  owner: string;
  subaccount?: string | undefined;
};

/** @internal */
export const AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$inboundSchema:
  z.ZodType<
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount,
    z.ZodTypeDef,
    unknown
  > = z.object({
    owner: z.string(),
    subaccount: z.string().optional(),
  });

/** @internal */
export type AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$Outbound = {
  owner: string;
  subaccount?: string | undefined;
};

/** @internal */
export const AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$outboundSchema:
  z.ZodType<
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$Outbound,
    z.ZodTypeDef,
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount
  > = z.object({
    owner: z.string(),
    subaccount: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$ {
  /** @deprecated use `AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$inboundSchema` instead. */
  export const inboundSchema =
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$inboundSchema;
  /** @deprecated use `AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$outboundSchema` instead. */
  export const outboundSchema =
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$outboundSchema;
  /** @deprecated use `AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$Outbound` instead. */
  export type Outbound =
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$Outbound;
}

export function appSchemasLedgersLedgerIcrc1MetadataMintingAccountToJSON(
  appSchemasLedgersLedgerIcrc1MetadataMintingAccount:
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount,
): string {
  return JSON.stringify(
    AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$outboundSchema.parse(
      appSchemasLedgersLedgerIcrc1MetadataMintingAccount,
    ),
  );
}

export function appSchemasLedgersLedgerIcrc1MetadataMintingAccountFromJSON(
  jsonString: string,
): SafeParseResult<
  AppSchemasLedgersLedgerIcrc1MetadataMintingAccount,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AppSchemasLedgersLedgerIcrc1MetadataMintingAccount$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AppSchemasLedgersLedgerIcrc1MetadataMintingAccount' from JSON`,
  );
}
